import { render, staticRenderFns } from "./unreadMessagesCount.vue?vue&type=template&id=279808a2"
import script from "./unreadMessagesCount.vue?vue&type=script&lang=js"
export * from "./unreadMessagesCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/francescobarbieri/Dev/brain/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('279808a2')) {
      api.createRecord('279808a2', component.options)
    } else {
      api.reload('279808a2', component.options)
    }
    module.hot.accept("./unreadMessagesCount.vue?vue&type=template&id=279808a2", function () {
      api.rerender('279808a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin-panel/components/sidebar/unreadMessagesCount.vue"
export default component.exports